import { render } from "./Proceso.vue?vue&type=template&id=864976a0"
import script from "./Proceso.vue?vue&type=script&lang=js"
export * from "./Proceso.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__